import { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import AuthDialog from "./components/AuthDialog";
import Library from "./pages/Library";
import BookDetail from "./pages/BookDetail";
import Reader from "./pages/Reader";
import Notes from "./pages/Notes";
import Shelf from "./pages/Shelf";
import AuthCallback from "./pages/AuthCallback";
import ShelfView from "./pages/ShelfView";
import Stats from "./pages/Stats";

function Shell() {
  const [authOpen, setAuthOpen] = useState(false);
  useAuth();
  const location = useLocation();

  // Detect Google OAuth callback synchronously — before the routes render.
  // Read hash from useLocation so React re-renders when history.replaceState clears it.
  if (location.hash?.includes("session_id=")) {
    return (
      <>
        <Header onOpenAuth={() => setAuthOpen(true)} />
        <AuthCallback />
      </>
    );
  }

  return (
    <>
      <Header onOpenAuth={() => setAuthOpen(true)} />
      <Routes>
        <Route path="/" element={<Library />} />
        <Route path="/book/:id" element={<BookDetail />} />
        <Route path="/read/:id" element={<Reader />} />
        <Route path="/shelf" element={<Shelf />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/shelves/:id" element={<ShelfView />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
      <AuthDialog open={authOpen} onOpenChange={setAuthOpen} />
      <Toaster
        position="bottom-right"
        toastOptions={{
          classNames: {
            toast: "font-ui bg-card text-card-foreground border border-border",
          },
        }}
      />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Shell />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}
